/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { factoryT, fields } from 'factory-t';
import {
    CashRegisterListDto,
    CashRegisterDto,
    InitOtpResponseDto,
    CashRegisterStatusHistoryDto,
    CashRegisterStatus,
} from './cashRegistersClient.typings';
import { CASH_REGISTER_MODEL_STATUS } from '../cashRegisterModels/cashRegisterModelsClient.typings';

const CASH_REGISTER_STATUSES: CashRegisterStatus[] = ['STOCK', 'READY', 'STORE', 'ELIMINATED'];

export const cashRegisterListDtoFactory = factoryT<CashRegisterListDto>({
    factoryNumber: (ctx) => `MANUFACTURER${String(ctx.index).padStart(9, '0')}`,
    modelTaxNumber: (ctx) => `04400200${ctx.index}`,
    registrationDate: '2020-02-02T11:27:11.996063',
    cashBoxTaxNumber: fields.sequence(['', '323476000', '67880000', '', '123456000']),
    status: fields.sequence(CASH_REGISTER_STATUSES),
    statusInsertedAtUtc: () => new Date().toISOString(),
    cashRegisterModelName: fields.sequence(['Mercury - 1', 'Sharp - 29', 'Siemens - 21-1']),
    operatorTaxNumber: (ctx) => `02000007${ctx.index}`,
});

export const cashRegisterDtoFactory = factoryT<CashRegisterDto>({
    factoryNumber: (ctx) => `MANUFACTURER${String(ctx.index).padStart(9, '0')}`,
    cashRegisterModelName: fields.sequence(['Mercury - 1', 'Sharp - 29', 'Siemens - 21-1']),
    cashRegisterModelTaxNumber: (ctx) => `000${ctx.index}`,
    operatorTaxNumber: (ctx) => `02000007${ctx.index}`,
    operatorName: 'Operator 1',
    modelStatus: fields.sequence([...CASH_REGISTER_MODEL_STATUS]),
    status: fields.sequence(CASH_REGISTER_STATUSES),
    statusInsertedAtUtc: () => new Date().toISOString(),
    fiscalDriverPublicKey: (ctx) => `public_key_${ctx.index}_base64_encoded`,
});

export const initOtpResponseDtoFactory = factoryT<InitOtpResponseDto>({
    otp: (ctx) => `D${String(280000 + ctx.index).padStart(6, '0')}`,
    expiredAt: () => {
        const expiredDate = new Date(Date.now() + 5 * 60 * 1000);
        return expiredDate.toISOString().replace('Z', '');
    },
});

export const cashRegisterStatusHistoryDtoFactory = factoryT<CashRegisterStatusHistoryDto>({
    status: fields.sequence(CASH_REGISTER_STATUSES),
    insertedAtUtc: (ctx) => {
        const date = new Date();
        date.setHours(date.getHours() - ctx.index);
        return date.toISOString();
    },
    userId: (ctx) => 1000 + ctx.index,
    userName: 'Ivan Ivanich',
    comment: fields.sequence(['Simple comment #1', 'Simple comment #2', 'Simple comment #3', '']),
    active: (ctx) => ctx.index === 0,
});
